module.exports = __webpack_public_path__ + "static/media/lifecycle-title.0871e2b4.png";